
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import autofit from 'autofit.js'
export default defineComponent({
  name: 'App',
  components: {
    Header,
    Footer
  },
  setup () {
    onMounted(() => {
      // console.log('App', document.querySelector('#app'))
      // autofit.init(
      //   {
      //     dh: 1080,
      //     dw: 1920,
      //     el: '#app',
      //     resize: true
      //   },
      //   false
      // )
    })
    onBeforeUnmount(() => {
      // autofit.off()
    })
    return {
      Header,
      Footer
    }
  }
})
